export interface OpcaoFiltroSelect {
  nzLabel?: string | number | null;
}

export function normalizarTextoBusca(valor: unknown): string {
  if (valor == null) {
    return '';
  }
  return String(valor)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

export function filtrarOpcaoSemAcento(input: string, option: OpcaoFiltroSelect): boolean {
  if (!input) {
    return true;
  }
  return normalizarTextoBusca(option?.nzLabel).includes(normalizarTextoBusca(input));
}
